import axios from "axios"
import { DELETE_LECTURE_FAILURE, DELETE_LECTURE_REQUEST, DELETE_LECTURE_SUCCESS, SET_DELETE_STATE } from "./actionType"

export const setDeleteState = (state) => (dispatch) => {
    dispatch({
        type: SET_DELETE_STATE,
        payload: state
    })
}

export const deleteLecture = (id, token) => (dispatch) => {
    dispatch({
        type: DELETE_LECTURE_REQUEST,
        payload: true
    })
    return axios.delete(`http://54.206.125.24:8888/api/lecture/removeLecture/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((res) => {
            console.log(res);
            dispatch({
                type: DELETE_LECTURE_SUCCESS,
                payload: res.data
            })
            return res.data;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: DELETE_LECTURE_FAILURE,
                payload: true
            })
        })
}